interface NumberFormatOptions {
  digitsInfo?: string;
  locale?: string;
}

export function formatNumber(value: number, options: NumberFormatOptions = {}): string {
  const { digitsInfo = '1.0-3', locale = 'en-US' } = options;

  const [minIntDigits, fractionalDigits] = digitsInfo.split('.');
  const [minFracDigits = '0', maxFracDigits = minFracDigits] = (fractionalDigits || '').split('-');

  const formatter = new Intl.NumberFormat(locale, {
    minimumIntegerDigits: parseInt(minIntDigits, 10),
    minimumFractionDigits: parseInt(minFracDigits, 10),
    maximumFractionDigits: parseInt(maxFracDigits, 10)
  });

  return formatter.format(value);
}
